import styled from 'styled-components';

export const Box = styled.div<{
  boxShadow: string | { boxShadow: string; filter: string };
}>`
  height: 300px;
  width: 300px;
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
  border: 1px solid ${(props) => props.theme.newPalette.neutral.N400};
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  display: flex;
  ${(props) => props.boxShadow};
`;

export const BoxContainer = styled.div`
  background-color: ${(props) => props.theme.newPalette.neutral.N0};
`;
